export default __webpack_public_path__ + "static/Bg-uk-ios-36004a1f79ac49a70f26f5e916ea4e00.webp";